var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "c-indicator-style" },
    [
      _c(
        "el-collapse",
        [
          _c(
            "el-collapse-item",
            { attrs: { title: "快捷布局" } },
            [
              _c("el-form-item", [
                _c("div", { staticClass: "carousel-select-item" }, [
                  _c("div", { staticClass: "arrows left-arrow" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      ref: "carouselGroup",
                      staticClass: "carousel-select-group",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "carousel-content" },
                        _vm._l([1, 2, 6], function (i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticClass: "carousel-select-group-item",
                              class: {
                                selected:
                                  _vm.selectItem.styleConfig.commongConfig
                                    .indicatorStyle === i,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.selectLayout(i)
                                },
                              },
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("@/assets/img/dashboard/lay" +
                                    i +
                                    ".png"),
                                  alt: "",
                                },
                              }),
                            ]
                          )
                        }),
                        0
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "arrows right-arrow" }),
                ]),
                _vm._v(" "),
                false
                  ? _c(
                      "div",
                      {
                        staticClass: "slick-dots slick-dots-bottom",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            $event.stopPropagation()
                          },
                        },
                      },
                      _vm._l(_vm.totalPages, function (page, index) {
                        return _c(
                          "li",
                          {
                            key: index,
                            class: {
                              "slick-active": _vm.currentPage === index,
                            },
                          },
                          [_c("button")]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-collapse-item",
            { attrs: { title: "指标内容" } },
            [
              _c(
                "style-sub-item",
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      { staticClass: "chart-form-item-warp" },
                      [
                        _c("span", { staticClass: "jz-chart-title-label" }, [
                          _vm._v("指标修饰"),
                        ]),
                        _vm._v(" "),
                        _c("el-switch", {
                          model: {
                            value:
                              _vm.selectItem.styleConfig.commongConfig
                                .indicatorIcon,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.selectItem.styleConfig.commongConfig,
                                "indicatorIcon",
                                $$v
                              )
                            },
                            expression:
                              "selectItem.styleConfig.commongConfig.indicatorIcon",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "c-indicator-item-list" },
                      _vm._l(_vm.dataList, function (item, idx) {
                        return _c(
                          "div",
                          { key: idx, staticClass: "c-indicator-item" },
                          [
                            _c("span", [_vm._v(_vm._s(item))]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "c-dimension-icon",
                                on: {
                                  click: function ($event) {
                                    return _vm.openIconSelector(item)
                                  },
                                },
                              },
                              [_c("i", { class: _vm.getIconForItem(item) })]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "icon-selector-dialog",
          attrs: {
            size: "mini",
            title: "选择图标",
            visible: _vm.iconSelectorVisible,
            width: "800px",
            "append-to-body": "",
            "before-close": _vm.closeIconSelector,
            "close-on-click-modal": false,
            "close-on-press-escape": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.iconSelectorVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "icon-category-list" },
            _vm._l(_vm.iconCategories, function (category, categoryKey) {
              return _c(
                "div",
                { key: categoryKey, staticClass: "icon-category-wrapper" },
                [
                  _c("div", { staticClass: "icon-category-title" }, [
                    _vm._v(_vm._s(category.title)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "icon-grid" },
                    _vm._l(category.icons, function (icon) {
                      return _c(
                        "div",
                        {
                          key: icon,
                          staticClass: "icon-item",
                          class: {
                            "icon-item-active": _vm.selectedIcon === icon,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.selectIcon(icon)
                            },
                          },
                        },
                        [_c("i", { class: icon })]
                      )
                    }),
                    0
                  ),
                ]
              )
            }),
            0
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                { staticClass: "footer-buttons" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "cancel-btn",
                      attrs: { size: "mini" },
                      on: { click: _vm.closeIconSelector },
                    },
                    [_vm._v("取消")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "confirm-btn",
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.confirmIconSelection },
                    },
                    [_vm._v("确定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }